import { ReportType } from '@lanterds/types';

export type ReportTypeMap = {
    [value in ReportType]: string;
};

export type ReportForm = {
    reportName: string;
    displayName: string;
    reportType: ReportType;
    displayPermission: string;
    reportDisplayName: string;
    reportGroup: string;
    powerBiReportName?: string;
    powerBiGroupId?: string;
    powerBiDatasets?: {
        datasetId: string;
        embedRole?: string;
    }[];
    sigmaPath?: string;
    sigmaReportName?: string;
    fmtpRoute?: string;
};

export const reportTypeMapObj: ReportTypeMap = {
    [ReportType.Sigma]: 'Sigma',
    [ReportType.PowerBi]: 'Power BI',
    [ReportType.PowerBiPaginated]: 'Power BI - Paginated',
    [ReportType.Fmtp]: 'FMTP',
};
